<template>
  <div class="con-info">
    <!-- 待复查 || 编辑-->
    <div
      class="awaitreview"
      v-if="!isOuter && (noticeReviewDetail.reviewresult === '待复查' || isEdit)"
    >
      <panelTitle title="复查情况" />
      <el-card>
        <el-form
          :model="reviewForm"
          :rules="rules"
          ref="reviewForm"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="复查结果：" prop="reviewresult">
            <el-radio-group v-model="reviewForm.reviewresult" size="mini" class="border_none_radio">
              <el-radio label="合格" border>合格</el-radio>
              <el-radio label="不合格" border>不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="复查截图：">
            <uploadPic
              ref="uploadPic"
              @getpic="getpic"
              :imgList="noticeReviewDetail.reviewurl || []"
            ></uploadPic>
            <div class="intro">支持上传9张截图，图片格式PNG、JPG，单张图片大小20M以内。</div>
          </el-form-item>
          <el-form-item label="复查说明：">
            <el-input
              type="textarea"
              placeholder="请输入备注说明，请保持在200字以内"
              maxlength="200"
              v-model="reviewForm.reviewstate"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="btn-wrap">
        <el-button type="primary" size="mini" @click="reviewConfirm()">确认</el-button>
        <el-button size="mini" @click="isEdit = false">取消</el-button>
      </div>
    </div>
    <!-- 已复查 -->
    <div
      class="reviewed"
      v-if="(noticeReviewDetail.reviewresult === '合格' || noticeReviewDetail.reviewresult === '不合格') && !isEdit"
    >
      <panelTitle title="复查情况" />
      <span class="update-time" v-if="!isOuter" @click="editClick" style="color: #108cee;">
        <i class="el-icon-edit"></i> 编辑
      </span>
      <el-card class="con-info">
        <div class="item">
          <span class="title">复查标价：</span>
          <p class="con" v-if="noticeReviewDetail.reviewbidprice">￥{{noticeReviewDetail.reviewbidprice}}</p>
        </div>
        <div class="item">
          <span class="title">复查到手价：</span>
          <p class="con" v-if="noticeReviewDetail.reviewtheirprice">￥{{noticeReviewDetail.reviewtheirprice}}</p>
        </div>
        <div class="item">
          <span class="title">优惠信息：</span>
          <p class="con">{{noticeReviewDetail.couponsstate}}</p>
        </div>
        <div class="item">
          <span class="title">复查结果：</span>
          <span class="con">{{noticeReviewDetail.reviewresult}}</span>
        </div>
        <div class="item">
          <span class="title">复查截图：</span>
          <div class="con img-wrap">
            <viewer :images="noticeReviewDetail.reviewurl">
              <img
                v-for="(item,index) in noticeReviewDetail.reviewurl"
                :src="item"
                alt
                :key="index"
              />
            </viewer>
          </div>
        </div>
        <div class="item">
          <span class="title">复查说明：</span>
          <p class="con">{{noticeReviewDetail.reviewstate}}</p>
        </div>
        <div class="item">
          <span class="title">复查人：</span>
          <p class="con">{{noticeReviewDetail.reviewkefu}}</p>
        </div>
        <div class="item" v-if="!isOuter">
          <span class="title">复查时间：</span>
          <p class="con">{{noticeReviewDetail.updatetime | fullTime}}</p>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import uploadPic from "@/views/CreditScore/common/uploadPic";
import panelTitle from "@/components/panelTitle";
import { fetchPost } from "@/libs/reqCommon";
import { mapState, mapActions } from "vuex";
export default {
  name: "responseInfo",
  components: { panelTitle, uploadPic },
  props: {
    isOuter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      reviewForm: {},
      rules: {
        reviewresult: [
          { required: true, message: "请选择复查结果", trigger: "change" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      noticeReviewDetail: state => state.noticeReview.noticeReviewDetail
    })
  },
  methods: {
    getpic(imgList) {
      this.reviewForm.reviewurl = imgList;
    },
    ...mapActions([
      "reqSaveReview",
      "reqNoticeReviewDetail",
      "reqNoticeReviewData",
      "reqNoticeReviewCount"
    ]),
    editClick() {
      this.isEdit = true;
      this.reviewForm = {
        reviewresult: this.noticeReviewDetail.reviewresult,
        reviewstate: this.noticeReviewDetail.reviewstate
      };
    },
    reviewConfirm() {
      this.$refs.reviewForm.validate(valid => {
        if (valid) {
          let query = {
            ...this.reviewForm,
            id: this.noticeReviewDetail.id,
            platform: this.noticeReviewDetail.platform
          };
          fetchPost("/hcm/wechatnotice/updatereview", query).then(res => {
            if (res.status === "10000") {
              this.$message({
                message: "复查成功",
                type: "success"
              });
              this.reqNoticeReviewDetail({ id: this.noticeReviewDetail.id });
              this.isEdit = false;
              this.$emit("closeResponse");
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    console.log(this.isOuter);
  }
};
</script>

<style lang="scss">
.btn-wrap {
  text-align: right;
  margin: 10px 0;
}
.border_none_radio {
  .el-radio__inner {
    display: none;
  }
  .el-radio__label {
    padding-left: 0;
  }
  .el-radio {
    margin-right: 20px;
  }
}
.screenshot {
  display: flex;
  flex-wrap: wrap;
  color: #666666;
  .avatar-uploader {
    background: #f7f8f8;
    border: 1px dashed #b5b5b5;
  }
  .uploading_pic_icon {
    width: 105px;
    height: 105px;
  }
  & > div {
    width: 105px;
    height: 105px;
    border-radius: 6px;
    margin-right: 20px;
    position: relative;
    text-align: center;
    margin-bottom: 5px;
  }

  .add_photo {
    border: 1px dashed #b5b5b5;
    text-align: center;
  }
  .el-icon-plus {
    color: #bfbfbf;
    font-size: 40px;
    margin-top: 25px;
  }
  .screenshot_pic {
    width: 100%;
    height: 100%;
  }
  .el-icon-error {
    font-size: 24px;
    color: #d81e06;
    position: absolute;
    top: -4px;
    right: -3px;
  }
}
.con-info {
  .item {
    position: relative;
    .title {
      vertical-align: middle;
      display: inline-block;
      width: 100px;
      text-align: right;
    }
    .con {
      display: inline-block;
      padding: 0 0 0 20px;
      width: calc(100% - 120px);
    }
    .edit {
      position: absolute;
      right: 0;
      cursor: pointer;
      color: #108cee;
    }
  }
}
.reviewed {
  position: relative;
  .update-time {
    position: absolute;
    top: 0;
    right: 30px;
    color: #666666;
  }
}
</style>
